import React from 'react';
import { Step } from 'react-joyride';
import { Box } from '@mui/material';

import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { ServiceTypes } from '@pharmaplan/common';

import { ReactComponent as Calendar } from '../assets/svg/calendar-grey.svg';
import genericClasses from '../theme/GenericClasses';
import strings from '../localization';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

const journeyStepsPharmacist = (): Array<Step | boolean> =>
  [
    {
      content: strings.profileBtn,
      target: '#avatarGuide',
      disableBeacon: true,
    },
    {
      content: strings.dashboardBtn,
      target: '#dashboard',
      disableBeacon: true,
    },
    {
      content: strings.pharmaciesServedGuide,
      target: '#myReplacements',
      disableBeacon: true,
    },
    {
      content: strings.reportsBtn,
      target: '#reports',
      disableBeacon: true,
    },
    isSelfService && {
      content: strings.selfPharmacistChatGuide,
      target: '#chat',
      disableBeacon: true,
    },
    {
      content: strings.availabilityWebBtn,
      target: '#availabilties',
      disableBeacon: true,
    },
    {
      content: strings.datePicker,
      target: '#calendarViewDropdown',
      disableBeacon: true,
    },
    {
      content: strings.todayBtn,
      target: '#today',
      disableBeacon: true,
    },
    {
      content: strings.watchlistIcon,
      target: '#watchlist',
      disableBeacon: true,
    },
    {
      content: strings.searchBtn,
      target: '#filter',
      disableBeacon: true,
    },
    {
      content: (
        <Box component="span">
          {strings.mapView}
          <Box component="span" sx={genericClasses.inlineIcon}>
            (
            <Calendar height={24} width={24} />
            )
          </Box>
          {strings.icon}
        </Box>
      ),
      target: '#map',
      disableBeacon: true,
      spotlightPadding: 3,
    },
    {
      content: strings.legendGuidePharmacist,
      target: '#legendContainer',
      disableBeacon: true,
    },
    {
      content: strings.notificationIconPharmacist,
      target: '#notificationIcon',
      disableBeacon: true,
    },
  ].filter(Boolean);

const journeyStepsPharmacy = (): Array<Step | boolean> =>
  [
    {
      content: strings.profileBtnPharmacy,
      target: '#avatarGuide',
      disableBeacon: true,
    },
    {
      content: strings.dashboardBtn,
      target: '#dashboard',
      disableBeacon: true,
    },
    {
      content: isSelfService
        ? strings.myReplacementsProfessionalBtn
        : strings.myReplacementsBtn,
      target: '#myReplacements',
      disableBeacon: true,
    },
    {
      content: strings.reportsBtnPharmacy,
      target: '#reports',
      disableBeacon: true,
    },
    isSelfService && {
      content: strings.selfPharmacyChatGuide,
      target: '#chat',
      disableBeacon: true,
    },
    {
      content: strings.myWorkShifts,
      target: '#availabilties',
      disableBeacon: true,
    },
    {
      content: strings.datePicker,
      target: '#calendarViewDropdown',
      disableBeacon: true,
    },
    {
      content: strings.todayBtn,
      target: '#today',
      disableBeacon: true,
    },
    {
      content: strings.legendGuide,
      target: '#legendContainer',
      disableBeacon: true,
    },
    {
      content: strings.notificationIcon,
      target: '#notificationIcon',
      disableBeacon: true,
    },
  ].filter(Boolean);

const journeyStepsButtons = () =>
  ({
    back: strings.backGuide,
    close: strings.close,
    last: strings.end,
    next: strings.next,
    skip: strings.skip,
  });

export { journeyStepsPharmacist, journeyStepsPharmacy, journeyStepsButtons };
